import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { changePassword } from './api';

const initialState = {};

const actions = {
  FORGOTPASSWORD: 'login/FORGOTPASSWORD'
};

export const forgotPassword = createAsyncThunk(
  actions.FORGOTPASSWORD,
  async (payload) => {
    const response = await changePassword('change-password', payload);
    return response;
  }
);

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    resetLoginDetails: (state) => {
      state.token = '';
      state.user = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(forgotPassword.fulfilled, (state) => {
        // Toasts handled by parent onSubmit — do not show here to avoid duplicates
        state.loading = false;
      })
      .addCase(forgotPassword.rejected, (state) => {
        // Toasts handled by parent onSubmit
        state.loading = false;
      });
  }
});

export default loginSlice.reducer;
